app.controller(
    'ShareUrlController', ['$scope', '$rootScope', '$stateParams', '$translate', '$sce', 'GroupService', 'SideBarService', 'BioService', 'ShareUrlService', 'DistrictService', 'FlaneriesService', 'HelperService', ShareUrlController]
);

function ShareUrlController($scope, $rootScope, $stateParams, $translate, $sce, GroupService, SideBarService, BioService, ShareUrlService, DistrictService, FlaneriesService, HelperService) {
    var vm = this;
    vm.AssociatedPlaces = [];

    vm.SharedUrlVm = {
        UserKey: '',
        Guid: 'TestGuid',
        Lang: $stateParams.lang
    };

    vm.SharedUrlIsExpired = false;
    vm.ShowSharedContent = false;
    //Password reset
    vm.ShowValidateEmailMessage = false;
    vm.ShowPasswordCreatedMessage = false;

    vm.HasError = false;
    vm.ErrorMessage = '';
    vm.CheckPwd = {};

    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }
    $translate.use($scope.CurrentLang);

    initController();

    function initController() {
        //CheckUrlExpiry();
    }

    //vm.CheckUrlExpiry = function () {
    //    ShareUrlService.CheckSharedUrlExpiry($stateParams.guid)
    //    .then(
    //            function success(response) {
    //                console.log("Url OK");                    
    //            },
    //            function error(response) {
    //                console.log("Url Expired");
    //                vm.HasError = true;
    //                vm.ErrorMessage = 'Votre lien est expiré.';
    //                vm.SharedUrlIsExpired = true;
    //            });
    //}

    vm.GetSharedContent = function () {
        if ($stateParams.guid) {
            vm.SharedUrlVm.Guid = $stateParams.guid;
            vm.ShowValidateEmailMessage = false;
            vm.HasError = false;
            ShareUrlService.GetSharedContent(vm.SharedUrlVm)
             .then(
                function success(response) {
                    switch (response.data.ErrorCode){
                        case "OK":
                            vm.PreviewType = response.data.Type;
                            switch (vm.PreviewType) {
                                case 'bio':
                                    vm.BioVm = response.data.Data;
                                    vm.AssociatedPlaces = vm.BioVm.AssociatedPlaceOnSideBarList;
                                    console.log(vm.AssociatedPlaces);
                                    break;
                                case 'group':
                                    vm.GroupVm = response.data.Data;
                                    vm.AssociatedPlaces = vm.GroupVm.AssociatedPlaceOnSideBarList;
                                    break;
                                case 'place':
                                    vm.PlaceVm = response.data.Data;
                                    vm.AssociatedPlaces = vm.PlaceVm.AssociatedPlaces;
                                    break;
                                case 'district':
                                    vm.DistrictVm = response.data.Data;                                    
                                    vm.AssociatedPlaces = vm.DistrictVm.AssociatedPlaces;
                                    break;
                                case 'itinerary':
                                    vm.ItineraryVm = response.data.Data;
                                    vm.AssociatedPlaces = vm.ItineraryVm.AssociatedPlaceOnSideBarList;
                                    break;
                                default:
                                    break;

                            }
                            vm.ShowSharedContent = true;
                            break;
                        case "ErrorUrlExpired":                            
                            vm.HasError = true;
                            vm.ErrorMessage = "Votre lien est expiré.";
                            vm.SharedUrlIsExpired = true;                            
                            break;

                        case "ErrorPassword":
                            console.log("ErrorPassword");
                            vm.HasError = true;
                            vm.ErrorMessage = "Votre mot de passe n'est pas le bon.";
                            break;
                        case "ContentNotFound":
                            vm.HasError = true;
                            vm.ErrorMessage = "Le contenu n'est pas disponible.";
                            break;
                        default:
                            break;
                    
                    }
                    
                },
                function error(response) {
                    vm.HasError = true;
                    vm.ErrorMessage = "Votre lien n'est pas le bon.";
                });
            //, function (response) {
            //    console.log("response");
            //    console.log(response);
            //    //vm.ValidateEmailResult = response.data;
            //    //vm.ShowValidateEmailMessage = true;
            //}
        }
        else {
            console.log("No guid");
        }
    }

    $scope.getHtml = function (htmlContent) {
        return $sce.trustAsHtml(htmlContent);
    };
}

